import React, { useRef } from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Slider from "react-slick"
// import Quote from "../../../icons/Quote.svg"
import styled from "@emotion/styled"
import parse from "html-react-parser"
import ArrowLeft from "../../../icons/ArrowLeftGrey.svg"
import ArrowRight from "../../../icons/ArrowRightGrey.svg"
import Button from "../../button/Button"
import Edges from "../../Edges"

interface ITestimonials {
  slides: Array<any>
  button: any
}

export const Testimonials = ({ slides = [], button = "" }: ITestimonials) => {
  const sliderSettings = {
    arrows: false,
    // dots: slides.length > 0 ? true : false,
    dots: false,
    infinite: slides?.length > 0 ? true : false,
    autoplaySpeed: 7000,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    // customPaging: () => (
    //   <div className="mt-6 h-full w-full whitespace-nowrap lg:mt-0">
    //     <div className="current h-[8px] w-[8px] bg-darkBlue text-yellow opacity-30  hover:bg-yellow hover:opacity-100" />
    //   </div>
    // ),
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const sliderRef = useRef()

  const nextSlide = e => {
    e && sliderRef.current.slickNext()
  }
  const prevSlide = e => {
    e && sliderRef.current.slickPrev()
  }

  return (
    slides && (
      <SlickContainer>
        <div className="relative h-full w-full bg-lightGrey pt-[54px]">
          <Edges size="2xl">
            <div className="relative">
              <div className="arrow absolute top-[48%] left-0 z-10 ml-[40px] sm:top-[50%] md:top-[45%] md:ml-[25px] lg:inset-y-[40%]">
                <ArrowLeft
                  onClick={e => prevSlide(e)}
                  className="cursor-pointer"
                />
              </div>
              <Slider {...sliderSettings} ref={sliderRef}>
                {slides?.map((slide, index) => {
                  const gatsbyImage =
                    slide?.image && getImage(slide?.image?.gatsbyImage)
                  return (
                    <div key={index}>
                      <div
                        className={`${
                          slide.alignImage === "left"
                            ? "lg:ml-[10%]"
                            : "lg:mr-[10%]"
                        } lg:relative lg:z-10 lg:pb-0 `}
                      >
                        <div
                          className={
                            slide.alignImage === "left"
                              ? "blockquote flex flex-row flex-wrap justify-center lg:flex-nowrap"
                              : "blockquote flex flex-row-reverse flex-wrap justify-center lg:flex-nowrap"
                          }
                        >
                          {gatsbyImage && (
                            <GatsbyImage
                              key={index}
                              image={gatsbyImage}
                              alt={slide.image?.altText}
                            />
                          )}
                          <div className="bg-darkBlue py-[50px] pl-[46px] lg:my-[50px] lg:py-[0px] lg:pt-[40px] lg:pb-[50px]">
                            <blockquote className="lg:pr-[256px]">
                              <div>
                                <p className="h-[60px] font-neusa text-[94px] text-yellow">
                                  “
                                </p>
                                {slide.title && (
                                  <h4 className="mt-6 text-white ">
                                    {slide.title}
                                  </h4>
                                )}
                                {slide.text && (
                                  <p className="mt-4 text-white lg:max-w-[610px] 2xl:max-w-[1000px]">
                                    {parse(slide.text)}
                                  </p>
                                )}
                              </div>
                              <footer className="mt-4">
                                {slide.name && (
                                  <h6 className="text-white">{slide.name}</h6>
                                )}
                              </footer>
                            </blockquote>
                          </div>
                        </div>
                      </div>
                      {button && button.url && (
                        <div
                          className={`${
                            slide.alignImage === "left" ? "lg:ml-2" : "lg:mr-8"
                          } mt-8 block flex w-full justify-center lg:mt-8`}
                        >
                          <Button
                            className="relative mx-auto mb-8 block sm:hidden md:mb-[62px]"
                            variant="secondary"
                            to={button.url}
                            size="medium"
                          >
                            {button.title}
                          </Button>
                          <Button
                            className="mb-8 hidden sm:block md:mb-[62px] "
                            variant="secondary"
                            to={button.url}
                            size="large"
                          >
                            {button.title}
                          </Button>
                        </div>
                      )}
                    </div>
                  )
                })}
              </Slider>
              <div className="arrow absolute top-[48%] right-0 z-10 mr-[40px]  sm:top-[50%] md:top-[45%] md:mr-[25px] lg:inset-y-[40%]">
                <ArrowRight
                  onClick={e => nextSlide(e)}
                  className="cursor-pointer"
                />
              </div>
            </div>
          </Edges>
        </div>
      </SlickContainer>
    )
  )
}

export default Testimonials

export const fragment = graphql`
  fragment Testimonials on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_Testimonials {
      fieldGroupName
      slides {
        alignImage
        name
        text
        title
        link {
          target
          title
          url
        }
        image {
          altText
          gatsbyImage(
            quality: 90
            height: 457
            width: 395
            layout: CONSTRAINED
            formats: [AUTO, WEBP]
          )
        }
      }
      button {
        target
        title
        url
      }
    }
  }
`
const SlickContainer = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
  position: relative;
  display: flex;
  align-items: center;
  img {
    border-radius: 4px;

    .slick-dots .slick-active .current {
      opacity: 1;
    }
  }
`
